// extracted by mini-css-extract-plugin
module.exports = {"root":"RequestHistoryAndMap_root__26SI7"};